import { get } from 'lodash';
import FilterDefinition from 'helpers/search_filters/filter_definition';

const buildSelector = path => query => get(query, `addressFilter.${path}`);

export const cities = new FilterDefinition({
  label: 'City',
  value: buildSelector('cities')
});

export const state = new FilterDefinition({
  label: 'State',
  value: buildSelector('state')
});

export const zip = new FilterDefinition({
  label: 'Zip',
  value: buildSelector('zip')
});

export default [
  cities,
  state,
  zip
];
